export const TKeyHeader = {} as const;
